import { APButton } from '@components/atoms/APButton';

import { EActionType, TProAmountButtonProps } from './types';

export const ProAmountButton = ({
  value,
  isSelected,
  currency,
  actionType,
  onClick,
}: TProAmountButtonProps) => {
  return actionType === EActionType.PRESET ? (
    <APButton
      text={`${value} ${currency}`}
      aria-pressed={isSelected}
      onClick={onClick}
      variant={isSelected ? 'primary' : 'secondary'}
      className="flex-1"
      size="medium"
    />
  ) : (
    <APButton
      textKey="AstroPayPro.other"
      icon="pencil"
      aria-pressed={isSelected}
      aria-label="Custom amount"
      onClick={onClick}
      variant={isSelected ? 'primary' : 'secondary'}
      className="flex-1"
      size="medium"
    />
  );
};
